import { BasicBotData, BotData, FiltersData, FilterType } from "@shared/types";
import { testStringListFilter } from "@shared/features/filters/utils";

export const filterBots = (
  bots: BotData[] | BasicBotData[] | undefined,
  filters: FiltersData
) => {
  return bots?.filter((botData) => {
    return testStringListFilter(
      filters[FilterType.CLIENTS]?.value,
      botData.client_name
    );
  });
};
